const REQUEST_QUOTATIONS_MEASUREMENTS = 'REQUEST_QUOTATIONS_MEASUREMENTS';
const REQUEST_SALES_TREND = 'REQUEST_SALES_TREND';

export { REQUEST_QUOTATIONS_MEASUREMENTS, REQUEST_SALES_TREND };
